import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {CommonService} from '../../../services/common.service';
import {ConsentsFormService} from '../../../services/consents-form.service';

@Component({
  selector: 'app-announcements-dialog',
  templateUrl: './announcements-dialog.component.html',
  styleUrls: ['./announcements-dialog.component.scss']
})
export class AnnouncementsDialogComponent implements OnInit {
  announcements: any;
  title = '';
  mode: number;
  user: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AnnouncementsDialogComponent>,
              public router: Router, public toastMessagesService: ToastMessagesService, private commonService: CommonService,
              private consentsFormService: ConsentsFormService) {
    this.announcements = data.announcements;
    this.title = data.title;
    this.mode = data.mode;
    this.user = data.user;
    for (const announcement of data.announcements) {
      if (announcement.dateDifference < 0) {
        announcement.sent = `Σήμερα`;
      } else if (announcement.dateDifference > 0 && announcement.dateDifference < 30) {
        announcement.sent = `${parseInt(announcement.dateDifference, 0)} ημ`;
      } else {
        let months = (announcement.dateDifference / 30);
        console.log(months);
        months = parseInt(String(months), 10);
        announcement.sent = `${months} Μ`;
      }
    }
  }

  ngOnInit(): void {
  }
  async navigate(notification: any) {
    const child = {id: notification.childId};
    await this.consentsFormService.showConsent(notification, this.user, child);
    this.close();
  }
  async showAnnouncement(announcementId) {
    const announcement = this.announcements.find(a => a.id === announcementId);
    announcement.is_opened = 1;
    await this.router.navigate(['home/announcement'], {queryParams: {id: announcementId}});
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  async readAll() {
    const unreadAnnouncements = this.announcements.filter(announcement => announcement.is_opened === 0);
    for (const announcement of unreadAnnouncements) {
      try {
        await this.commonService.updateItem(`people/parents/announcements?id=${announcement.id}`, {});
        announcement.is_opened = 1;
      } catch (e) {
        this.toastMessagesService.toastErrorMessage(e.message);
      }
    }

  }

  // tslint:disable-next-line:variable-name
  onSwipeLeft($event: any, number: number) {
    this.toastMessagesService.toastMessages(`Swipe Left`);
  }

  // tslint:disable-next-line:variable-name
  onSwipeRight($event: any, number: number) {
    this.toastMessagesService.toastMessages(`Swipe Right`);

  }

  async displayAnnouncement(announcement: any) {
    // if (announcement.mode === 'affirmation' || announcement.mode === 'consent') {
      await this.navigate(announcement);
    // }
  }
}
